import { useState } from 'react';
import { Box, Typography } from '../../../components/ui';
import type { ArticleStep } from '../../../types/knowledgeBase';
import './StepCard.css';

interface StepCardProps {
  step: ArticleStep;
}

export function StepCard({ step }: StepCardProps) {
  const [imageExpanded, setImageExpanded] = useState(false);

  const handleImageClick = () => {
    if (step.imageUrl) {
      setImageExpanded(true);
    }
  };

  const handleCloseExpanded = () => {
    setImageExpanded(false);
  };

  return (
    <Box className="step-card">
      <Box className="step-card__header">
        <span className="step-card__number">Step {step.stepNumber}</span>
        <Typography variant="h6" component="h3" className="step-card__title">
          {step.title}
        </Typography>
      </Box>

      <Box className="step-card__content">
        <Typography variant="body1" className="step-card__text">
          {step.content}
        </Typography>

        {step.imageUrl && (
          <Box className="step-card__image-container">
            <img
              src={step.imageUrl}
              alt={step.imageAlt ?? `Step ${step.stepNumber} illustration`}
              className="step-card__image"
              onClick={handleImageClick}
            />
            <Typography variant="caption" className="step-card__image-hint">
              Click to enlarge
            </Typography>
          </Box>
        )}
      </Box>

      {/* Expanded Image Modal */}
      {imageExpanded && step.imageUrl && (
        <Box className="step-card__modal" onClick={handleCloseExpanded}>
          <Box className="step-card__modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="step-card__modal-close"
              onClick={handleCloseExpanded}
              aria-label="Close image"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 6L6 18M6 6l12 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>
            <img
              src={step.imageUrl}
              alt={step.imageAlt ?? `Step ${step.stepNumber} illustration (expanded)`}
              className="step-card__modal-image"
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
